// extracted by css-extract-rspack-plugin
export default {"cls1":"PaywallPage-cls1_PwI","cls2":"PaywallPage-cls2_pf3 PaywallPage-cls1_PwI"};